import _styled from "@emotion/styled/base";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React from 'react';
import { PlateLeaf, useElement } from 'platejs/react';
import { useLink } from '@platejs/link/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const StyledA = /*#__PURE__*/_styled("a", {
  target: "ez1d5340",
  label: "StyledA"
})(process.env.NODE_ENV === "production" ? {
  name: "11z7vuy",
  styles: "text-decoration:underline;font-size:inherit"
} : {
  name: "11z7vuy",
  styles: "text-decoration:underline;font-size:inherit/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9SaWNodGV4dENvbnRyb2wvY29tcG9uZW50cy9FbGVtZW50L0xpbmtFbGVtZW50LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUt3QiIsImZpbGUiOiIuLi8uLi8uLi8uLi8uLi9zcmMvUmljaHRleHRDb250cm9sL2NvbXBvbmVudHMvRWxlbWVudC9MaW5rRWxlbWVudC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBQbGF0ZUxlYWYsIHVzZUVsZW1lbnQgfSBmcm9tICdwbGF0ZWpzL3JlYWN0JztcbmltcG9ydCB7IHVzZUxpbmsgfSBmcm9tICdAcGxhdGVqcy9saW5rL3JlYWN0JztcblxuY29uc3QgU3R5bGVkQSA9IHN0eWxlZC5hYFxuICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTtcbiAgZm9udC1zaXplOiBpbmhlcml0O1xuYDtcblxuZnVuY3Rpb24gTGlua0VsZW1lbnQoeyBjaGlsZHJlbiwgLi4ucmVzdCB9KSB7XG4gIGNvbnN0IGVsZW1lbnQgPSB1c2VFbGVtZW50KCk7XG4gIGNvbnN0IHsgcHJvcHMgfSA9IHVzZUxpbmsoeyBlbGVtZW50IH0pO1xuICByZXR1cm4gKFxuICAgIDxQbGF0ZUxlYWYgYXNDaGlsZCB7Li4ucHJvcHN9IHsuLi5yZXN0fT5cbiAgICAgIDxTdHlsZWRBPntjaGlsZHJlbn08L1N0eWxlZEE+XG4gICAgPC9QbGF0ZUxlYWY+XG4gICk7XG59XG5cbmV4cG9ydCBkZWZhdWx0IExpbmtFbGVtZW50O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function LinkElement({
  children,
  ...rest
}) {
  const element = useElement();
  const {
    props
  } = useLink({
    element
  });
  return ___EmotionJSX(PlateLeaf, _extends({
    asChild: true
  }, props, rest), ___EmotionJSX(StyledA, null, children));
}
export default LinkElement;